<template>
  <div>
    <mt-field label="学生手机号" placeholder="请输入手机号" type="tel" v-model="phone"></mt-field>
    <div class="btn-area">
      <mt-button type="primary" @click="query">查询学生信息</mt-button>
      <mt-button type="danger" @click="quitClass">学生退班</mt-button>
    </div>
    <div class="info">
      <div class="title">详情信息</div>
      <mt-cell title="老师名称" :value="teacherName"></mt-cell>
      <mt-cell title="老师电话" :value="teacherPhone"></mt-cell>
      <mt-cell title="班级编码" :value="classCode"></mt-cell>
      <mt-cell title="班级名称" :value="className"></mt-cell>
      <mt-cell title="学生名称" :value="studentName"></mt-cell>
      <mt-cell title="学生电话" :value="studentPhone"></mt-cell>
    </div>
  </div>
</template>

<script>
import MainService from '@/service/main'
export default {
  name: 'StudnetOperation',
  data () {
    return {
      phone: '',
      teacherName: '',
      teacherPhone: '',
      classCode: '',
      className: '',
      classId: 0,
      studentName: '',
      studentPhone: '',
      studentId: 0,
      session: ''
    }
  },
  methods: {
    query () {
      if (this.phone === '') this.$toast('请输入学生手机')
      else {
        this.$indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        MainService.getStudentClassInfo(this.phone)
          .then(res => {
            if (res.data.result_code === 200) {
              if (res.data.data) {
                this.teacherName = res.data.data.teacher_name
                this.teacherPhone = res.data.data.teacher_code
                this.classId = res.data.data.class_id
                this.classCode = res.data.data.class_code
                this.className = res.data.data.class_name
                this.studentId = res.data.data.student_id
                this.studentName = res.data.data.student_name
                this.studentPhone = res.data.data.student_code
                this.session = res.data.data.session
              } else {
                this.$toast('不存在此学生！')
              }
            }
          })
          .catch(res => {
            console.log(res)
          })
          .finally(() => this.$indicator.close())
      }
    },
    quitClass () {
      if (this.studentId !== 0 && this.classId !== 0 && this.teacherPhone !== '' && this.session !== '') {
        this.$messagebox.confirm('确定要从班级剔除此学生吗？')
          .then(action => {
            this.$indicator.open({
              text: '处理中...',
              spinnerType: 'fading-circle'
            })
            MainService.delClassStudent(this.teacherPhone, this.session, 7, this.classId, this.studentId)
              .then(res => {
                if (res.data.result_code === 200) {
                  this.$toast('处理成功')
                } else {
                  this.$messagebox.alert({
                    message: '处理数据失败！',
                    title: '提示信息',
                    showCancelButton: false
                  })
                }
              })
              .catch(res => {
                console.log(res)
              })
              .finally(() => this.$indicator.close())
          })
          .catch(action => {
            console.log(action)
          })
      }
    }
  }
}
</script>

<style scoped>
  .btn-area {
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .info {
    margin-top: 15px;
    width: 100%;
    background-color: #fff;
  }

  .info .title {
    font-size: 14px;
    color: #999;
    padding: 20px 15px 10px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/StudentOperation.vue